module.exports = {"330182001":"新安江街道","330182002":"洋溪街道","330182003":"更楼街道","330182101":"莲花镇","330182102":"乾潭镇","330182104":"梅城镇","330182105":"杨村桥镇","330182106":"下涯镇","330182107":"大洋镇","330182108":"三都镇","330182109":"寿昌镇","330182110":"航头镇","330182111":"大慈岩镇","330182112":"大同镇","330182113":"李家镇","330182202":"钦堂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330182.json
// module id = 953
// module chunks = 0